export const links = {
  success: '/success',
  failed: '/failed',
  sbpsuccess: '/sbpsuccess',
  main: '/:ticket',
};

export default links;
